import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import SellIcon from "@mui/icons-material/Sell";
import CreatableSelect from "react-select/creatable";
import Cookies from "js-cookie";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Select from "react-select";
import { get } from "react-hook-form";

const AddLead = () => {
  const [selectedTag, setSelectedTag] = useState([]);
  console.log(selectedTag);
  const { baseUrl, openToast, fetchLead } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChangetags = (selectedOptions) => {
    setSelectedTag([...selectedOptions]);
  };
  const handleChangevalues = (selectedOptions1) => {
    const Values = selectedOptions1.map((option) => parseFloat(option.value));
    setLeadValue(Values);
  };
  const handleChangelanguage = (selectedOptions3) => {
    const languageValues = selectedOptions3.map((option) => option.value);
    console.log(languageValues);
    setLeadDefaultLanguage(languageValues);
  };
  const [tags, setTags] = useState([
    { value: "thumbnail", label: "thumbnail" },
    { value: "youtube", label: "youtube" },
    { value: "youtube thumbnail", label: "youtube thumbnail" },
    { value: "carousel", label: "carousel" },
    { value: "RE-DESIGN", label: "REDESIGN" },
    { value: "Ads", label: "Ads" },
    { value: "drdcrcrc", label: "drdcrcrc" },
  ]);
  const [values, setValues] = useState([
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "30", label: "30" },
    { value: "40", label: "40" },
    { value: "50", label: "50" },
  ]);
  const [language, setLanguage] = useState([
    { value: "english", label: "english" },
    { value: "france", label: "france" },
    { value: "hindi", label: "hindi" },
  ]);

  const [leadname, setLeadName] = useState("");
  const [leadposition, setLeadPosition] = useState("");
  const [leademail, setLeadEmail] = useState("");
  const [leadwebsite, setLeadWebsite] = useState("");
  const [leadphone, setLeadPhone] = useState("");
  const [leadvalue, setLeadValue] = useState([]);
  const [leadcurrencysymbol, setLeadCurrencySymbol] = useState(["₹"]);
  const [leadaddress, setLeadAddress] = useState();
  const [leadcity, setLeadCity] = useState("");
  const [leadstate, setLeadState] = useState("");
  const [leadcountry, setLeadCountry] = useState("");
  const [leadzipCode, setLeadZipCode] = useState("");
  const [leaddefaultLanguage, setLeadDefaultLanguage] = useState([]);
  const [leadcompany, setLeadCompany] = useState("");
  const [leaddescription, setLeadDescription] = useState("");
  const [leadisPublic, setLeadIsPublic] = useState(false);
  const [fetchAllLeads, setFetchAllLeads] = useState([]);

  async function getAllLeads() {
    try {
      const response = await fetch(
        baseUrl + `lead/count`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      // console.log(response);

      const result = await response.json();
      if (response.status === 200) {
        console.log(result);
        setFetchAllLeads(result);
      } else {
        console.log(result);
      }
    } catch (error) {
      console.error("Error retrieving leave requests:", error);
    }
  }

  async function addLead() {
    try {
      setIsLoading(true);

      // Object containing all required fields with their display names
      const requiredFields = {
        leadname: "Name",
        leademail: "Email",
        leadphone: "Phone",
        leadposition: "Position",
        leadcompany: "Company",
        leadwebsite: "Website",
        leadvalue: "Lead Value",
        leadcurrencysymbol: "Currency Symbol",
        leadaddress: "Address",
        leadcity: "City",
        leadstate: "State",
        leadcountry: "Country",
        leadzipCode: "Zip Code",
        leaddefaultLanguage: "Default Language",
        leaddescription: "Description",
        leadisPublic: "Lead Visibility",
        selectedTag: "Tags",
      };

      // Loop through required fields and check if any are empty or invalid
      for (const [key, fieldName] of Object.entries(requiredFields)) {
        if (
          !eval(key) ||
          (Array.isArray(eval(key)) && eval(key).length === 0)
        ) {
          throw new Error(`Please fill the ${fieldName} field`);
        }
      }

      const response = await fetch(baseUrl + `lead/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          name: leadname,
          position: leadposition,
          email: leademail,
          website: leadwebsite,
          phone: leadphone,
          leadValue: leadvalue,
          currencySymbol: leadcurrencysymbol,
          address: leadaddress,
          city: leadcity,
          state: leadstate,
          country: leadcountry,
          zipCode: leadzipCode,
          defaultLanguage: leaddefaultLanguage,
          company: leadcompany,
          description: leaddescription,
          isPublic: leadisPublic,
          tags: selectedTag.map((option) => option.value),
        }),
      });
      const result = await response.json();
      // console.log(result, "sdrjoesijfoiehufihsd")

      if (response.status === 201) {
        openToast("Lead added successfully", "success");
        navigate("/lead-detail");
        fetchLead()
      }
      else {
        // console.log(result.issues[0]);
        openToast(result.issues[0] || "error");
      }
    } catch (error) {
      openToast(`Error: ${error.message}`, "error");
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getAllLeads();
  }, []);




  return (
    <div className="flex flex-col justify-center items-center min-h-screen">
      <div className="border-gray-100 bg-white shadow-cs mt-[20px] md:mt-[30px] mb-[30px] md:mb-[30px] border rounded-lg w-[90%] md:w-[80%]">
        <h2 className="flex gap-4 border-[#B1B1B1] p-[14px] border-b font-medium text-[18px] cursor-pointer">
          Lead
        </h2>
        <div className="p-[20px]">
          <div>
            <label className="font-medium text-gray-700 text-sm">
              {" "}
              Name <span className="text-red-500">*</span>
            </label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadName(e.target.value)}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">
              Position
            </label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadPosition(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">City</label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadCity(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">Email</label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadEmail(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">State</label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadState(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">Website</label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadWebsite(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">Country</label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadCountry(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">Phone</label>
            <br />
            <input
              type="number"
              onChange={(e) => setLeadPhone(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">
              Zip Code
            </label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadZipCode(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px] mb-[10px]">
            <label className="font-medium text-gray-700 text-sm">
              Lead Value
            </label>
            <br />
            <CreatableSelect
              isMulti
              options={values}
              onChange={handleChangevalues}
              placeholder="Select or add value..."
              className="w-full tag-selector"
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "35px",
                  border: "1px solid #d1d5db",
                }),
                multiValue: (provided) => ({
                  ...provided,
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                }),
                multiValueLabel: (provided) => ({
                  ...provided,
                  fontSize: "0.875rem",
                }),
                multiValueRemove: (provided) => ({
                  ...provided,
                  color: "#4b5563",
                  cursor: "pointer",
                }),
              }}
              required
            />
          </div>
          <div className="inline-block relative mb-[6px] w-[100%] text-left">
            <label
              htmlFor="currencySymbol"
              className="block font-medium text-gray-700 text-sm"
            >
              currency
            </label>
            {/* <Select
              name="currencySymbol"
              closeMenuOnSelect={false}
              isMulti
              defaultValue={[{ label: "INR", value: "₹" }]}
              onChange={(o) => {
                const arr = o.map((op) => op.value);
                setLeadCurrencySymbol(arr);
              }}
              options={[
                { label: "USD", value: "$" },
                { label: "INR", value: "₹" },
              ]}
            /> */}

            <Select
              name="currencySymbol"
              closeMenuOnSelect={false}
              isMulti
              onChange={(o) => {
                const arr = o.map((op) => op.value);
                setLeadCurrencySymbol(arr);
              }}
              options={[
                { label: "USD", value: "$" },
                { label: "INR", value: "₹" },
              ]}
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">
              Default Language
            </label>
            <br />
            <CreatableSelect
              isMulti
              options={language}
              onChange={handleChangelanguage}
              placeholder="Select or add language..."
              className="w-full tag-selector"
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "35px",
                  border: "1px solid #d1d5db",
                }),
                multiValue: (provided) => ({
                  ...provided,
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                }),
                multiValueLabel: (provided) => ({
                  ...provided,
                  fontSize: "0.875rem",
                }),
                multiValueRemove: (provided) => ({
                  ...provided,
                  color: "#4b5563",
                  cursor: "pointer",
                }),
              }}
              required
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">Company</label>
            <br />
            <input
              type="text"
              onChange={(e) => setLeadCompany(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="block mb-1 font-medium text-gray-700 text-sm">
              Tags
            </label>
            <div className="flex items-center gap-[10px]">
              <SellIcon />
              {/* <span className="pl-2 font-medium">Tags</span> */}
              <CreatableSelect
                isMulti
                options={tags}
                onChange={handleChangetags}
                value={selectedTag}
                placeholder="Select or add tags..."
                className="w-full tag-selector"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "35px",
                    border: "1px solid #d1d5db",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    fontSize: "0.875rem",
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: "#4b5563",
                    cursor: "pointer",
                  }),
                }}
                required
              />
            </div>
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">
              {" "}
              Address
            </label>
            <br />
            <textarea
              type="text"
              onChange={(e) => setLeadAddress(e.target.value)}
              rows={8}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="mt-[6px]">
            <label className="font-medium text-gray-700 text-sm">
              Description
            </label>
            <br />
            <textarea
              type="text"
              onChange={(e) => setLeadDescription(e.target.value)}
              rows={4}
              className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
            />
          </div>
          <div className="flex items-center gap-[10px] mt-[6px]">
            <input
              type="checkbox"
              onChange={(e) => setLeadIsPublic(e.target.checked)}
            />
            <p>Public</p>
          </div>

          <div className="flex justify-end gap-[10px] mt-3 text-end">
            <Link
              to="/lead-detail"
              className="flex items-center hover:bg-[#7526d1] py-2 pt-2 pr-5 pl-5 rounded-md text-white first-btn"
            >
              Cancel
            </Link>

            <button
              type="submit"
              onClick={addLead}
              disabled={isLoading}
              className={`allcrm-btn1 ${isLoading ? "opacity-40" : ""}`}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLead;
